import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import { ISOTService } from '../../services';

export interface CountdownDialogConfig {
  /** timeout seconds befor auto close */
  timeout: number;
  sot_service: ISOTService;
}

interface CountdownDialogButton {
  langkey: string;
  onClick: (dialog_ref: MatDialogRef<CountdownDialogComponent>) => void;
  /** style defaults to "", "action" = highlight */
  style?: "" | "action";
}

@Component({
  selector: "sot-countdowndialog",
  templateUrl: "./countdowndialog.component.html",
  styleUrls: ["./countdowndialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountdownDialogComponent implements OnInit, OnDestroy {

  private _sotService: ISOTService;
  public text: string = "dialog_still_there";
  public buttons: CountdownDialogButton[] = [{
    langkey: "dialog_still_there_no",
    onClick: (dialog) => { dialog.close("no") }
  }, {
    langkey: "dialog_still_there_yes",
    onClick: (dialog) => { dialog.close("yes") },
    style: "action"
  }];
  public buttons_in_row: boolean = true;
  public timeout: number = 10;

  public constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<CountdownDialogComponent, "yes" | "no" | "timeout">,
    @Inject(MAT_DIALOG_DATA) public data: CountdownDialogConfig,
    private _coreLogService: CoreLogService
  ) {
    this._sotService = data.sot_service;
    this.timeout = Math.min(Math.max(data.timeout, 5), 60);
  }

  public ngOnInit(): void {
    console.debug("--- sot-countdowndialog ngOnInit");
    this.PushChanges();
  }
  public get isModeOne(): boolean {
    return this.data.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.data.sot_service.Accessabilty.useModeTwo;
  }
  public ngOnDestroy(): void {
    console.debug("--- sot-countdowndialog ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("CountdownDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public countdownStatusChanged(status: "start" | "stop" | "done"): void {
    if (status == "done") {
      this.dialogRef.close("timeout");
    } // else not relevant ignore
  }
}
